var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.calendar/app/components/event-create-button/event-create-button.pug");
module.exports = (req['default'] || req).apply(req, [])